import React from "react";

import { JsonLdContainerProps } from "~/bff/components/JsonLdContainer";

export const SeoJsonLdContainer = ({ items }: JsonLdContainerProps) => {
  return <>{items}</>;
};
